import React from "react";
import { useNavigate} from "react-router-dom";

function Categories({items, index}) {    
  const navigate = useNavigate();   
  return (
      <div className="compCust">
        <div className="compWrapper">
          <h3 className="compTitle">Customization. <span>Let's do more with PowerSchool</span></h3>
          <div className="gridContainer">

            <div className="custWrapper"
             onClick={() => {
              navigate(`/customization/utilities/condense_school_list`);
            }}>
              <div className="custContainer">
              <img src="/images/utilities2.png" loading="lazy" style={{width:"100%"}} alt={items.utilities.title} title={items.utilities.title}/>
              </div>
              <div className="custDetails">
                <p className="custCateg">{items.utilities.title}</p>
                <p className="custDesc">{items.utilities.description}</p>
                <p className="learnmore" title={items.utilities.title}>Learn More ></p>
              </div>
            </div>

            <div 
             className="custWrapper"
             onClick={() => {
              navigate(`/customization/searchtools/condense_school_list`);
            }}>
              <div className="custContainer">
                <img src="/images/searchtools.png" loading="lazy" style={{width:"100%"}} alt={items.searchtools.title} title={items.searchtools.title}/>
              </div>
              <div className="custDetails">
                <p className="custCateg">{items.searchtools.title}</p>
                <p className="custDesc">{items.searchtools.description}</p>
                <p className="learnmore" title={items.searchtools.title}>Learn More ></p>
              </div>
            </div>

            <div 
              className="custWrapper"
              onClick={() => {
              navigate(`/customization/contacts/consolidate_contacts`);
            }}>
              <div className="custContainer">
                <img src="/images/contacts.png" loading="lazy" style={{width:"100%"}} alt={items.contacts.title}  title={items.contacts.title}/>
              </div>
              <div className="custDetails">
                <p className="custCateg">{items.contacts.title}</p>
                <p className="custDesc">{items.contacts.description}</p>
                <p className="learnmore" title={items.contacts.title}>Learn More ></p>
              </div>
            </div>

          </div>
        </div>
      </div>
  );
}

export default Categories;